import { useFlags } from "flagsmith/react";
import { useUser } from "./useUser";

interface ChatAccess {
	isChatDisabled: boolean;
	isChatEnabled: boolean;
}

export function useChatAccess(): ChatAccess {
	const flags = useFlags(["disable_chat"]);
	const { user } = useUser();

	const flag = flags?.disable_chat;

	// If flag doesn't exist or is not enabled, chat is enabled for everyone
	if (!flag || !flag.enabled) {
		return {
			isChatDisabled: false,
			isChatEnabled: true,
		};
	}

	// Flag is enabled, so chat is disabled by default
	// Check if user is in the exception list (users who CAN still access chat)
	if (!flag.value || !user?.id) {
		return {
			isChatDisabled: true,
			isChatEnabled: false,
		};
	}

	// Parse comma-separated list of user IDs who are exempt from the disable
	const exemptUserIds = String(flag.value)
		.split(",")
		.map((id) => id.trim())
		.filter((id) => id !== "")
		.map((id) => parseInt(id, 10))
		.filter((id) => !isNaN(id));

	// Check if current user is exempt from the disable
	const isUserExempt = exemptUserIds.includes(user.id);

	return {
		isChatDisabled: !isUserExempt,
		isChatEnabled: isUserExempt,
	};
}
